import React from 'react';
import ParkingDisplayForm from './ParkingDisplayForm';

export default function AddParkingDisplay() {
  return <ParkingDisplayForm />;
}
